import React from "react";
import OrganizationsContent from "../components/organizations/organizations-content";

const Organizations = () => {
  return <OrganizationsContent />;
};

export default Organizations;
